import React from 'react'
import PropTypes from 'prop-types'
import { useSelector } from 'react-redux'
import { Box, Slide } from '@mui/material'
import Icon from 'components/design-system/Icon'

// Toast theo type: Figma "Toast / Success" (99:17010); error / warning / info cùng layout, đổi sang token status tương ứng
const VARIANTS = {
  success: { icon: 'check', bg: 'var(--color-status-success-bg)', border: 'var(--color-status-success-border)' },
  error: { icon: 'cancel', bg: 'var(--color-status-error-bg)', border: 'var(--color-status-error-border)' },
  warning: { icon: 'info', bg: 'var(--color-status-warning-bg)', border: 'var(--color-status-warning-border)' },
  info: { icon: 'info', bg: 'var(--color-status-info-bg)', border: 'var(--color-status-info-border)' }
}

const Toast = ({ notification }) => {
  const v = VARIANTS[notification.type] || VARIANTS.info

  return (
    <Box
      role={notification.type === 'error' ? 'alert' : 'status'}
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: 'var(--space-8)',
        boxSizing: 'border-box',
        width: notification.width,
        maxWidth: 'min(480px, calc(100vw - 32px))',
        px: 'var(--space-16)',
        py: 'var(--space-8)',
        bgcolor: v.bg,
        border: `var(--stroke-default) solid ${v.border}`,
        borderRadius: 'var(--radius-md)',
        boxShadow: '4px 4px 16px 0 rgba(0, 0, 0, 0.3)', // Shadow/Card
        fontFamily: 'var(--font-family-primary)',
        fontSize: 'var(--font-size-14)', // Body/14 Regular
        fontWeight: 'var(--font-weight-regular)',
        lineHeight: 'normal',
        color: 'var(--color-text-primary)',
        whiteSpace: 'pre-wrap',
        pointerEvents: 'auto'
      }}
    >
      <Icon name={v.icon} size={20} color="var(--color-icon-default)" />
      <Box component="span" sx={{ minWidth: 0, overflowWrap: 'anywhere' }}>
        {notification.message}
      </Box>
    </Box>
  )
}

Toast.propTypes = {
  notification: PropTypes.shape({
    type: PropTypes.oneOf(['success', 'error', 'warning', 'info']),
    message: PropTypes.node,
    width: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
  }).isRequired
}

/** Danh sách toast: giữa màn hình, sát đáy; toast mới nằm dưới cùng. */
const AlertList = () => {
  const alerts = useSelector((state) => state.alert.alerts)

  return (
    <Box
      aria-live="polite"
      sx={{
        position: 'fixed',
        left: '50%',
        bottom: 'var(--space-24)',
        transform: 'translateX(-50%)',
        zIndex: 9999,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: 'var(--space-8)',
        pointerEvents: 'none' // không chặn click vào map / nội dung phía sau
      }}
    >
      {alerts.map((al) => (
        <Slide key={al.id} in={al.visible} direction="up">
          <div>
            <Toast notification={al} />
          </div>
        </Slide>
      ))}
    </Box>
  )
}

export default AlertList
